module.exports = __webpack_public_path__ + "static/sertifika-izmir-dokuz-eylul-sergisi-6a95ccecf575276817a0ffa21c2905c3.jpg";